import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import css from './Price.module.scss';

interface Props {
  className?: string;
  price: number;
  isMonthly?: boolean;
}

const Price = (props: Props & InjectedIntlProps) => {
  return (
    <span className={classNames(css.Price, props.className)}>
      {props.isMonthly && (
        <span className={css.Price__Montyly}>
          {props.intl.formatMessage({ id: 'merchants.common.price.monthly' })}
        </span>
      )}
      <span className={css.Price__Emphasis}>
        {props.intl.formatNumber(props.price)}
      </span>
      {props.intl.formatMessage({ id: 'merchants.common.price.unit' })}
    </span>
  );
};

export default injectIntl(Price);
